/**
 * state mặc định của module
 */
import commonFunction from '../../common/commonFunction';
export default {
	updateColumnExports(state, res) {
		if (state.ColumnExports.length > 0) {
			let indexColumn = state.ColumnExports.findIndex(
				x => x.TypeExport == res.Data.TypeExport && x.ColumnExportId == res.Data.ColumnExportId
			);
			if (indexColumn >= 0) {
				state.ColumnExports[indexColumn] = res.Data;
			} else {
				state.ColumnExports.push(res.Data);
			}
		} else {
			state.ColumnExports.push(res.Data);
		}
	},

	clearColumnExport(state, res) {
		state.ColumnExport = [];
	}
};
